import React from 'react'

const ViewStudent = () => {
  return (
    <div>ViewStudent</div>
  )
}

export default ViewStudent